import React from 'react';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  NEXT_BUTTON_TEXT,
  PREVIOUS_BUTTON_TEXT,
  SELECT_MONTH,
} from '../../../constants';
import './CustomToolbar.css';

const CustomToolbar = () => {
  return class BaseToolBar extends Toolbar {
    handleNavigate = (detail, elem) => {
      detail.navigate(elem);
    };

    setIsOpen = (value) => {
      this.setState({
        isForcePickerOpen: value,
      });
    };

    handleDateChange = (value) => {
      this.setState({
        selectedDate: value,
      });
      const { onNavigate } = this.props;
      onNavigate('NEXT' - 1, new Date(value));
    };

    handleClick = (event) => {
      const { isForcePickerOpen } = this.state;
      this.setIsOpen(!isForcePickerOpen);
      this.setState({
        anchorEl: event?.currentTarget,
      });
    };

    state = {
      isForcePickerOpen: false,
      selectedDate: new Date(),
      anchorEl: null,
    };

    render() {
      const { label } = this.props;
      const { isForcePickerOpen } = this.state;
      return (
        <Box className="posr">
          <Box className="rbc-btn-group ">
            <Tooltip
              title={
                <Typography sx={{ fontSize: '0.8rem' }}>
                  {PREVIOUS_BUTTON_TEXT}
                </Typography>
              }
              placement="right"
            >
              <Button
                size="small"
                type="button"
                className="prevp-btn"
                onClick={() => {
                  this.handleNavigate(this, 'PREV');
                }}
              >
                <ArrowBackIosIcon fontSize="small" />
              </Button>
            </Tooltip>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                views={['month', 'year']}
                value={label}
                open={isForcePickerOpen}
                onClose={() => this.setIsOpen(false)}
                onChange={this.handleDateChange}
                PopperProps={{
                  placement: 'bottom',
                  anchorEl: this.state.anchorEl,
                }}
                renderInput={({ disabled, onChange, value }) => (
                  <Box className="rbc-btn-group ">
                    <input
                      style={{ display: 'none' }}
                      value={value}
                      onChange={onChange}
                      disabled={disabled}
                    />
                    <Tooltip
                      title={
                        <Typography sx={{ fontSize: '0.8rem' }}>
                          {SELECT_MONTH}
                        </Typography>
                      }
                      placement="top"
                    >
                      <Button
                        type="button"
                        className="defaultbtn css-input"
                        onClick={this.handleClick}
                      >
                        <Typography>{label}</Typography>
                      </Button>
                    </Tooltip>
                  </Box>
                )}
              />
            </LocalizationProvider>
            <Tooltip
              title={
                <Typography sx={{ fontSize: '0.8rem' }}>
                  {NEXT_BUTTON_TEXT}
                </Typography>
              }
              placement="left"
            >
              <Button
                type="button"
                className="nextp-btn"
                onClick={() => this.handleNavigate(this, 'NEXT')}
              >
                <ArrowForwardIosIcon fontSize="small" />
              </Button>
            </Tooltip>
          </Box>
        </Box>
      );
    }
  };
};
export default CustomToolbar;
